import { Button } from "@/components/ui/button";
import { Plus, Building2 } from "lucide-react";

interface GymHeaderProps {
  onCreateNew: () => void;
}

export const GymHeader = ({ onCreateNew }: GymHeaderProps) => {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-center">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-primary/10">
          <Building2 className="h-5 w-5 text-primary" />
        </div>
        <h2 className="text-2xl font-bold text-foreground">Mis Gimnasios</h2>
      </div>
      <Button 
        onClick={onCreateNew}
        className="w-full sm:w-auto bg-primary hover:bg-primary/90 shadow-sm"
      >
        <Plus className="mr-2 h-4 w-4" />
        Nuevo Gimnasio
      </Button>
    </div>
  );
};
